enum ContributorConstants {
  GET_CONTRIBUTORS_LIST = "GET_CONTRIBUTORS_LIST",
  GET_CONTRIBUTORS_LIST_SUCCESS = "GET_CONTRIBUTORS_LIST_SUCCESS",
  GET_CONTRIBUTORS_LIST_FAILURE = "GET_CONTRIBUTORS_LIST_FAILURE",

  GET_LYRICISTS_LIST_SUCCESS = "GET_LYRICISTS_LIST_SUCCESS",
  GET_LYRICISTS_LIST_FAILURE = "GET_LYRICISTS_LIST_FAILURE",

  GET_COMPOSERS_LIST_SUCCESS = "GET_COMPOSERS_LIST_SUCCESS",
  GET_COMPOSERS_LIST_FAILURE = "GET_COMPOSERS_LIST_FAILURE",

  GET_ARTISTS_LIST_SUCCESS = "GET_ARTISTS_LIST_SUCCESS",
  GET_ARTISTS_LIST_FAILURE = "GET_ARTISTS_LIST_FAILURE",

  ADD_CONTRIBUTOR_REQ = "ADD_CONTRIBUTOR_REQ",
  ADD_CONTRIBUTOR_REQ_SUCCESS = "ADD_CONTRIBUTOR_REQ_SUCCESS",
  ADD_CONTRIBUTOR_REQ_FAILURE = "ADD_CONTRIBUTOR_REQ_FAILURE",

  EDIT_CONTRIBUTOR_REQUEST = "EDIT_CONTRIBUTOR_REQUEST",
  EDIT_CONTRIBUTOR_SUCCESS = "EDIT_CONTRIBUTOR_SUCCESS",
  EDIT_CONTRIBUTOR_FAILURE = "EDIT_CONTRIBUTOR_FAILURE",

  DELETE_CONTRIBUTOR_REQUEST = "DELETE_CONTRIBUTOR_REQUEST",
  DELETE_CONTRIBUTOR_SUCCESS = "DELETE_CONTRIBUTOR_SUCCESS",
  DELETE_CONTRIBUTOR_FAILURE = "DELETE_CONTRIBUTOR_FAILURE",

  RESET_CONTRIBUTORS = "RESET_CONTRIBUTORS",
}

export default ContributorConstants;
